import axios from "axios";
import env from "../variables/EndpointEnvironment";

const SolutionBannerAPI = (props) => {
  return axios.get(`${env.HOST}/bannerSolusi?loc=${props.type}&orderBy=asc`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    }
  });
};

export default SolutionBannerAPI;